var React = require('react');

function CrossIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.5,2.61c1.35-1.33,3.26,0.52,3.26,0.52l14.9,14.9c0,0,2.4,2.18,0.74,3.54c-1.65,1.37-3.71-1.15-3.71-1.15L2.88,5.61C2.88,5.61,1.16,3.93,2.5,2.61z M2.54,21.53c-1.4-1.47,0.81-3.5,0.81-3.5L18.11,3.26c0,0,1.8-2.16,3.25-0.79c1.45,1.37-0.53,3.43-0.53,3.43L6.25,20.48C6.25,20.48,3.94,23,2.54,21.53z"}));
}

CrossIcon.defaultProps = {"data-dmid":"dm-cross","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","fill":"currentColor","pointerEvents":"none","color":"color2"};

module.exports = CrossIcon;

CrossIcon.default = CrossIcon;
